module.exports = __webpack_public_path__ + "static/media/placeholder.019224da.jpg";